import React, { useCallback, useState } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import { BotoAjuda } from "./AjudaModal";
import AjudaRecursos from "./AjudaRecursos";
import "../dashboard_v2.css";

/**
 * Pàgina genèrica dels CRUD de Recursos (mateixa màquina d'estats que Productes:
 * llista ↔ fitxa). Cada recurs aporta el seu component de llista i de fitxa.
 *
 * Config: { titol, subtitol, icona, textNou, pestanyaAjuda, idDe, Llista, Fitxa }
 */
function PaginaRecursos({ config }) {
  const { titol, subtitol, icona, textNou, pestanyaAjuda, idDe, Llista, Fitxa } = config;
  const { rolUsuari } = useUserContext();
  const [activeTab, setActiveTab] = useState("seleccionar");
  const [selected, setSelected] = useState(null);
  const [filtres, setFiltres] = useState({ text: "", activitat: "actius" });
  const [reloadToken, setReloadToken] = useState(0);
  const [llista, setLlista] = useState([]);
  const [meta, setMeta] = useState({});
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const tornarLlista = (refresca = false) => {
    setActiveTab("seleccionar");
    if (refresca) setReloadToken((n) => n + 1);
  };

  const handleSelect = useCallback(
    (fila) => {
      if (!fila) {
        setSelected(null);
        return;
      }
      setSelected((prev) => (idDe(prev) === idDe(fila) ? null : fila));
    },
    [idDe]
  );

  const obrirFitxa = (fila, mode) => {
    setSelected(fila);
    setActiveTab(mode);
  };

  const esLlista = activeTab === "seleccionar";

  return (
    <div className="dv2 dv2-page dv2-page--fill">
      {mostraAjuda && <AjudaRecursos pestanya={pestanyaAjuda} onTancar={() => setMostraAjuda(false)} />}
      {esLlista ? (
        <>
          <div className="dv2-pageHeader">
            <div className="dv2-pageHeader-main">
              <div className="dv2-pageHeader-icon" aria-hidden="true">
                {icona}
              </div>
              <div>
                <h1 className="dv2-pageHeader-title">{titol}</h1>
                <p className="dv2-pageHeader-subtitle">{subtitol}</p>
              </div>
            </div>
            <div className="dv2-pageHeader-actions">
              <BotoAjuda title={`Com funcionen els ${titol}`} onClick={() => setMostraAjuda(true)} />
              {tincPermis(rolUsuari, "CREAR") && (
                <button
                  type="button"
                  className="dv2-btn dv2-btn--primary"
                  onClick={() => {
                    setSelected(null);
                    setActiveTab("nou");
                  }}
                >
                  {textNou}
                </button>
              )}
            </div>
          </div>
          <Llista
            selected={selected}
            onSelect={handleSelect}
            onObrir={obrirFitxa}
            onMeta={setMeta}
            reloadToken={reloadToken}
            setLlista={setLlista}
            filtres={filtres}
            setFiltres={setFiltres}
          />
        </>
      ) : (
        <Fitxa
          mode={activeTab}
          record={activeTab === "nou" ? null : selected}
          llista={llista}
          meta={meta}
          onNavigate={setSelected}
          onCancel={() => tornarLlista(false)}
          onCanviarMode={setActiveTab}
          onSave={(actualitzat) => {
            if (activeTab === "nou") {
              tornarLlista(true);
              return;
            }
            setSelected((prev) => ({ ...prev, ...actualitzat }));
            setLlista((prev) =>
              (prev || []).map((f) => (idDe(f) === idDe(actualitzat) ? { ...f, ...actualitzat } : f))
            );
            setReloadToken((n) => n + 1);
            setActiveTab("consultar");
          }}
          onEstatCanviat={() => tornarLlista(true)}
        />
      )}
    </div>
  );
}

export default PaginaRecursos;
